export default __webpack_public_path__ + "static/media/ethiopia2.9a8c9091.jpeg";